module.exports = __webpack_public_path__ + "img/contact.1eec20df.png";